import * as Sentry from '@sentry/browser';

import AppSettings from '../../constants';
import { Role } from '../model/role.model';

let instance = null;

export class RoleService {
    role;

    static getInstance() {
        if (!instance) {
            instance = new RoleService();
        }
        return instance;
    }

    create(token, user, group, companies) {
        const apiUrl = AppSettings.auth0.audience;
        this.role = new Role(
            token[`${apiUrl}/authorities`],
            token[`${apiUrl}/accessLevel`],
            token[`${apiUrl}/companyAccesses`],
            user,
            group,
            companies
        );
        return this.role;
    }

    reset() {
        this.role = undefined;
        Sentry.setUser(null);
    }

    authenticated() {
        if (this.role) {
            Sentry.setUser({ id: this.role.user.id, email: this.role.user.email, segment: this.role.user.userType });
        }
    }

    get() {
        return this.role;
    }
}
